<template>
    <div class="body-panel">
        <div class="body-panel-control separator">
            <div class="control-block-left">
                <div class="flex">

                </div>
            </div>
            <div class="control-block-right">
                <button type="button" class="btn" @click="">Добавить</button>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page">


        </div>

        <vue-headful title="Продавцы" />
    </div>
</template>

<script>
    export default {
        name: "sellers"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/Sellers.vue